import {createStyles, makeStyles} from '@material-ui/core';
import {IconButton} from '@material-ui/core/';
import Paper from '@material-ui/core/Paper';
import {MenuBook} from '@material-ui/icons';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import {lookupModality} from 'features/instance/component/StageGrid';
import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';
import useLoadActivity from '../hooks/useLoadActivity';
import {LookupProps} from 'components/grid-dx/MasterGrid';
import moment from 'moment';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {useActionButtonStyles} from 'components/grid-dx/styles/actionButtonStyles';

interface ToCapacitationsProps {
  row: any;
  setRedirect: React.Dispatch<
    React.SetStateAction<{
      active: boolean;
      path: string;
      iD_Course: never[];
      iD_Instance: never[];
      modality: number;
      expired: boolean;
    }>
  >;
}

interface StatusProps {
  status: number;
  text: string;
}

interface UpdateDateProps {
  value: string;
  data: any;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    statusButton: {
      paddingTop: '1px',
      paddingBottom: '1px',
      textAlign: 'center',
    },
    button: {
      width: 20,
      height: 20,
      color: '#4040a1',
    },
  }),
);

export const lookupStatus = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Sin empezar')},
      {id: 1, name: i18n2._('Terminado')},
      {id: 2, name: i18n2._('En Progreso')},
      {id: 4, name: i18n2._('Suspendido')},
    ],
    key: 'id',
  },
};

export const Status = ({status, text}: StatusProps) => {
  const classes = useStyles();
  switch (status) {
    case 0:
      return (
        <Paper className={`red-background white-text ${classes.statusButton}`}>
          {text}
        </Paper>
      );
    case 1:
      return (
        <Paper
          className={`green-background white-text ${classes.statusButton}`}>
          {text}
        </Paper>
      );
    case 2:
      return (
        <Paper
          className={`yellow-background white-text ${classes.statusButton}`}>
          {text}
        </Paper>
      );
    case 4:
      return (
        <Paper className={`grey-background white-text ${classes.statusButton}`}>
          {text}
        </Paper>
      );
    default:
      return (
        <Paper className={`red-background white-text ${classes.statusButton}`}>
          {text}
        </Paper>
      );
  }
};

const Calification = ({value}: any) => {
  return <div>{value * 100}%</div>;
};

const UpdateDate = ({value, data}: UpdateDateProps) => {
  return data.data.status === 1 ? <div>{data.text}</div> : <div></div>;
};

const ToCapacitations = ({row, setRedirect}: ToCapacitationsProps) => {
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();

  if (row.modality !== 0 || row.status === 1 || row.status === 4) {
    return null;
  }

  const expirationDate = moment(row.expiration_Date, 'YYYY-MM-DD');
  var current = moment().startOf('day');

  return (
    <IconButton
      size="small"
      color={'primary'}
      title={i18n2._('Realizar Curso')}
      className={isTablet ? styles.tabletButton : styles.compactButton}
      onClick={() => {
        setRedirect({
          active: true,
          path: './Capacitation',
          iD_Course: row.iD_Course,
          iD_Instance: row.iD_Instance,
          modality: row.modality,
          expired: moment.duration(expirationDate.diff(current)).asDays() < 0,
        });
      }}>
      <MenuBook
        className={isTablet ? styles.tabletIcon : styles.compactButton}
      />
    </IconButton>
  );
};

const ActivityGrid = () => {
  const capacitation = {
    active: false,
    path: '',
    iD_Course: [],
    iD_Instance: [],
    modality: 0,
    expired: false,
  };
  const [redirect, setRedirect] = useState(capacitation);
  const isTablet = useIsTablet();
  const loadAttended = useLoadActivity();
  return (
    <IntegrityRoleGrid
      dataSource={loadAttended}
      id={['iD_Course, iD_Sector, iD_Profile']}
      allowIntegrity={false}
      allowActions={false}>
      <Column caption={i18n2._('#Course')} dataField="iD_Course" width="6%" />
      <Column
        caption={i18n2._('#Instancia')}
        dataField="iD_Instance"
        width="7%"
      />
      <Column
        caption={i18n2._('Documento')}
        dataField="doc_Number"
        width="10%"
      />
      <Column caption={i18n2._('Curso')} dataField="name" width="50%" />
      <Column
        caption={i18n2._('Estado')}
        dataField="status"
        width="10%"
        cellComponent={(props) => (
          <Status status={props.data.value} text={props.data.text} />
        )}>
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>

      <Column
        caption={i18n2._('Finalización')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
        cellComponent={(props) => (
          <UpdateDate value={props.data.value} data={props.data} />
        )}
        width="10%"
      />
      <Column
        caption={i18n2._('Expiración')}
        defaultSortOrder={'desc'}
        dataField="expiration_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) =>
          row.expiration_Date ? new Date(row.expiration_Date) : null
        }
        width="10%"
      />
      <Column caption={i18n2._('Modality')} dataField="modality" width="8%">
        <Lookup
          dataSource={lookupModality}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column
        caption={i18n2._('Calificación')}
        dataField="score"
        cellComponent={(props: any) => (
          <Calification value={props.data.value} />
        )}
        width="10%"
      />
      <Column
        caption=""
        cellComponent={(e: any) => (
          <ToCapacitations row={e.data.data} setRedirect={setRedirect} />
        )}
        width={isTablet ? 85 : 45}
        fixed
        alignment="right"
      />
      {redirect.active && redirect.modality === 0 ? (
        <Redirect
          to={{
            pathname: redirect.path,
            state: {
              iD_Course: redirect.iD_Course,
              iD_Instance: redirect.iD_Instance,
              modality: redirect.modality,
              expired: redirect.expired,
            },
          }}
        />
      ) : (
        <></>
      )}
    </IntegrityRoleGrid>
  );
};

export default ActivityGrid;
